import { Component, OnInit, Optional } from "@angular/core";
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import {
  AlertController,
  IonicModule,
  LoadingController,
  ModalController,
  NavController,
  NavParams,
  ToastController,
} from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { PessoaProvider } from "src/app/services/pessoa/pessoa";
import { UserProvider } from "src/app/services/user/user";
import { Storage } from "@ionic/storage-angular";
import { QrCodePage } from "./qr-code/qr-code.page";
import { ParticipacoesPage } from "../participacoes/participacoes.page";
import { ConfiguracaoPage } from "../configuracao/configuracao.page";
import { DadosGeraisPage } from "./dados-gerais/dados-gerais.page";
import { ActivatedRoute, Router } from "@angular/router";
import { CommonModule } from "@angular/common";
import { LoadingSpinnerComponent } from "src/app/components/loading/loading-spinner/loading-spinner.component";
import { ImagePipe } from "src/app/pipes/image/image";
import { NotificacaoPage } from "../notificacao/notificacao.page";
import { SemRegistroComponent } from "src/app/components/sem-registro/sem-registro";
import { DateFormatPipe } from "src/app/pipes/date-format/date-format";
import { PerfilProfissionalPage } from "./perfil-profissional/perfil-profissional.page";

declare var instituicaoConstants: {
  IS_CATHOLIC: any;
  IS_CONVENCAO: any;
  BUSCAR_INTITUICOES: number;
  TOKEN_ANONIMO: any;
  IS_PWA: boolean;
};

@Component({
  selector: "app-modal-pessoa",
  templateUrl: "./modal-pessoa.page.html",
  styleUrls: ["./modal-pessoa.page.scss"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    LoadingSpinnerComponent,
    TranslateModule,
    ImagePipe,
    SemRegistroComponent,
    DateFormatPipe
  ],
})
export class ModalPessoaPage implements OnInit {
  pessoa: any = { contato: {}, endereco: {}, hasMda: {} };
  public isCatholic: boolean = instituicaoConstants.IS_CATHOLIC;
  public isConvencao: boolean = instituicaoConstants.IS_CONVENCAO;
  public isControle: boolean = false;
  loaded: boolean = false;
  meuCadastro: boolean = false;
  mostrarCamera: boolean = false;
  membro: boolean = false;
  isVisitante: boolean;
  editar: boolean = false;
  esconderCadastro: boolean = true;
  pessoaTipo: boolean = false;
  cadastroModal: boolean = false;
  autorizado: any;
  visitante: any;
  idPessoa: any;
  idPessoaRoute: any;
  idPessoaModal: any;
  cadastroRoute: any;
  display: string = "dados";
  isChrome: any;
  key: string = "";
  usuario: any;
  login!: FormGroup;
  permissao: any;
  statusPessoaTipo: any;
  statusPessoa: any;
  nomeUsuario: any;
  error: boolean = false;
  permissaoStatus: any;
  keyInstituicao: string = "";
  notificationsLength: any;
  origemGrupos: boolean;
  isMobile: any = {
    Android: function () {
      return navigator.userAgent.match(/Android/i);
    },
    iOS: function () {
      return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    any: function () {
      return this.isMobile.Android() || this.isMobile.iOS();
    },
  };

  constructor(
    public navCtrl: NavController,
    @Optional() private navParams: NavParams,
    public viewCtrl: NavController,
    public pessoaProvider: PessoaProvider,
    public modalCtrl: ModalController,
    public loadingController: LoadingController,
    public userProvider: UserProvider,
    public toastCtrl: ToastController,
    private translate: TranslateService,
    public alertCtrl: AlertController,
    public router: Router,
    public active: ActivatedRoute,
    public storage: Storage
  ) {}

  ngOnInit() {
    this.extractNavParams();
    this.processInstituicaoData();
    this.buildLoginForm();
    this.fetchStatusPessoa();
    this.fetchPessoaData();
    this.extractUserData();
    this.checkEditPermissions();
    this.mostrarCamera = true;
    this.pessoaProvider.getCountNotification().subscribe((result) => {
      this.notificationsLength = result;
    });
  }

  private extractNavParams() {
    const params = {
      membro: this.navParams?.get("membro"),
      permissao: this.navParams?.get("permissao"),
      idPessoa: this.navParams?.get("idPessoa") || this.active.snapshot.paramMap.get("idPessoa"),
      meuCadastro: this.navParams?.get("meuCadastro") || this.active.snapshot.paramMap.get("meucadastro"),
      autorizado: this.navParams?.get("autorizado"),
      origemGrupos: this.navParams.get("origem"),
      isVisitante: this.navParams.get("isVisitante"),
    };

    this.membro = params.membro;
    this.permissao = params.permissao;
    this.idPessoa = params.idPessoa;
    this.meuCadastro = params.meuCadastro || this.idPessoa == this.userProvider.loggedUser.id;
    this.autorizado = params.autorizado;
    this.origemGrupos = params.origemGrupos
  }

  private processInstituicaoData() {
    this.isControle = instituicaoConstants.BUSCAR_INTITUICOES == 2;
    this.userProvider.getDadosInstituicao().then((data) => {
      this.keyInstituicao = data.apiToken;
    });
  }

  private buildLoginForm() {
    this.usuario = this.userProvider.loggedUser.login;
    this.login = new FormGroup({
      usuario: new FormControl(this.usuario, Validators.required),
      password: new FormControl("", Validators.required),
    });
  }

  private fetchStatusPessoa() {
    this.pessoaProvider.getStatusPessoa(this.idPessoa).subscribe((data: { statusNome: any; statusPessoa: any }) => {
      this.statusPessoaTipo = data.statusNome;
      this.statusPessoa = data.statusPessoa;
    });
  }

  private extractUserData() {
    this.permissaoStatus = this.userProvider.hasPermissao("PESSOA_VISUALIZAR");
    this.userProvider.getDados().then((res) => {
      this.key = res.apiKey;
    });
  }

  private fetchPessoaData() {
    this.pessoaProvider.getbyId(this.idPessoa).subscribe((data: any) => {
      this.pessoa = data;
      this.nomeUsuario = this.pessoa.nome;
      setTimeout(() => {
        this.loaded = true;
      }, 1000);
    });
  }

  private checkEditPermissions() {
    this.editar =
      (this.userProvider.hasPermissao("PESSOA_EDITAR") && this.pessoa.idPessoaTipo !== 5) ||
      (this.userProvider.hasPermissao("VISITANTE_EDITAR") && this.pessoa.idPessoaTipo === 5) ||
      this.meuCadastro;
  }

  public async closeModal() {
    if (this.idPessoaRoute) {
      this.router.navigate(["home-custom"]);
    } else {
      this.modalCtrl.dismiss();
    }
  }

  async openParticipacao() {
    var aux = {
      membro: this.membro,
      permissao: this.permissao,
      idPessoa: this.idPessoa,
      meuCadastro: this.meuCadastro,
      isControle: this.isControle,
      origemGrupos: this.origemGrupos,
      isVisitante: this.isVisitante
    };
    const modalPage = await this.modalCtrl.create({ component: ParticipacoesPage, componentProps: aux });
    modalPage.present();
  }

  async openConfiguracao() {
    let aux = {
      membro: this.membro,
      permissao: this.permissao,
      idPessoa: this.idPessoa,
      meuCadastro: this.meuCadastro,
      isControle: this.isControle,
    };
    const modalPage = await this.modalCtrl.create({ component: ConfiguracaoPage, componentProps: aux });
    modalPage.present();

    const { data } = await modalPage.onWillDismiss();
    if (data) {
      this.modalCtrl.dismiss(null, "close", "modalPessoaId");
    }
  }

  async openDadosGerais() {
    const data = {
      membro: this.membro,
      permissao: this.permissao,
      idPessoa: this.idPessoa,
      meuCadastro: this.meuCadastro,
      isControle: this.isControle,
      autorizado: this.autorizado,
    };
    const modalPage = await this.modalCtrl.create({ component: DadosGeraisPage, componentProps: data });
    modalPage.present();

    const dismissModal = await modalPage.onDidDismiss();
    if (dismissModal) {
      this.fetchPessoaData();
    }
  }

  async openProfissional() {
    const modalPage = await this.modalCtrl.create({ 
      component: PerfilProfissionalPage, 
      componentProps: {
        idPessoa: this.idPessoa,
        pessoaNome: this.pessoa.nome,
        idProfissao: this.pessoa.profissao,
      },
    });
    modalPage.present();
  }

  async sair() {
    const alert = await this.alertCtrl.create({
      cssClass: "alerta-personalizado",
      mode: "ios",
      header: this.translate.instant("Sair do Aplicativo"),
      message: this.translate.instant(
        "Após sair será necessário informar seu usuário e senha novamente para acessar o aplicativo!"
      ),
      buttons: [
        {
          text: this.translate.instant("Cancelar"),
          role: "cancel",
          handler: () => {},
        },
        {
          text: this.translate.instant("Sair"),
          cssClass: "danger",
          handler: () => {
            this.userProvider.logout().then(async (result) => {
              if (instituicaoConstants.TOKEN_ANONIMO) {
                this.userProvider.loggedUser = null;
                await this.storage.set("token", instituicaoConstants.TOKEN_ANONIMO);
                await this.userProvider.atualizarDadosPessoa().toPromise();
                this.userProvider.sendMessage("tabs");
                this.router.navigate(["tabs"]);
                this.modalCtrl.dismiss();
              } else {
                this.router.navigate(["login"]);
                this.modalCtrl.dismiss();
              }
            });
          },
        },
      ],
    });
    await alert.present();
  }

  public async qrCode(pessoa: { id: any; nome: any; foto: any; instituicao: any }) {
    let data = { idPessoa: pessoa.id, nome: pessoa.nome, foto: pessoa.foto, idInstituicao: pessoa.instituicao.id };
    const modalPage = await this.modalCtrl.create({ component: QrCodePage, componentProps: data });
    modalPage.present();
  }

  changeListener($event: { target: any }): void {
    this.readThis($event.target);
  }

  readThis(inputValue: any): void {
    var file: File = inputValue.files[0];
    var myReader: FileReader = new FileReader();

    myReader.onloadend = async (e) => {
      let data = { browser: false, image: myReader.result, pessoa: this.idPessoa };
      const modalPage = await this.modalCtrl.create({ component: "FotoPage", componentProps: data });
      modalPage.present();

      (await modalPage.onDidDismiss()).data;
      if (data) {
        this.pessoa.foto = data;
      }
    };

    myReader.readAsDataURL(file);
  }

  async notificacoes() {
    const modalPage = await this.modalCtrl.create({ component: NotificacaoPage, componentProps: this.idPessoa });
    modalPage.present();
  }
}
